// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"6147e621","453":"acec9a3f"}[chunkId] + ".chunk.js";
};